import React from "react"
import PropTypes from "prop-types"
function CustomerDeptSelect({
  options,
  value,
  onChange,
  disabled,
  pageName,
  className,
  notMandate,
  toolTip
}) {
  return (
    <div
      className={
        pageName === "bNumber"
          ? "form-group d-inline-flex"
          : `form-group ${className}`
      }
      style={pageName === "bNumber" ? { marginLeft: "34%" } : { marginLeft: 0 }}
    >
      <label for="ref-no">
        Customer / Department
        {!notMandate && (
          <span className="text-danger madatory-asterisk">*</span>
        )}
      </label>
      <select
        class={`form-control`}
        name="customer"
        title={toolTip ? `${toolTip.custName} - ${toolTip.deptName}` : null}
        value={value}
        onChange={e => {
          const [customer, departmentId] = e.target.value.split("-")
          onChange(e.target.name, customer, departmentId)
        }}
        disabled={disabled}
      >
        <option value="">--select--</option>
        {options !== undefined &&
          Array.isArray(options) &&
          options.map((customer, index) => (
            <option
              key={index}
              id="select"
              title={`${customer.customerName}-${customer.departmentName}`}
              name={index}
              value={`${customer._id}-${customer.departmentId}`}
            >
              {customer.customerName}-{customer.departmentName}
            </option>
          ))}
      </select>
    </div>
  )
}

export default CustomerDeptSelect


// WEBPACK FOOTER //
// ./src/components/Field/CustomerDeptSelect.js